"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var circuitBreaker_1 = require("./circuitBreaker");
//tslint:disable-next-line:no-unnecessary-class
var CircuitBreakersStore = /** @class */ (function () {
    function CircuitBreakersStore() {
    }
    CircuitBreakersStore.getCircuitBreaker = function (hash, options) {
        if (!CircuitBreakersStore.circuitBreakers[hash]) {
            CircuitBreakersStore.circuitBreakers[hash] = new circuitBreaker_1.CircuitBreaker(options);
        }
        else {
            CircuitBreakersStore.circuitBreakers[hash].setConfig(options);
        }
        return CircuitBreakersStore.circuitBreakers[hash];
    };
    CircuitBreakersStore.circuitBreakers = {};
    return CircuitBreakersStore;
}());
exports.CircuitBreakersStore = CircuitBreakersStore;
//# sourceMappingURL=circuitBreakersStore.js.map